import { render, staticRenderFns } from "./ClassCreate.vue?vue&type=template&id=46d64cc0&scoped=true&"
import script from "./ClassCreate.vue?vue&type=script&lang=js&"
export * from "./ClassCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d64cc0",
  null
  
)

export default component.exports